<template>
  <div>
    <blockquote
      class="quote"
      cite="#source of the quote"
    >
      <div>
        {{ quote.content }}

        <cite> {{ quote.person }}
        </cite>
      </div>
    </blockquote>
  </div>
</template>

<script>


export default {
  name: 'QuotationBlock',
  props: {
    quote: {
      type: Object,
      default: () => ({
        content: '',
        person: '',
      }),
    },
  },
};
</script>
